const users = {
    page_title: 'การจัดการผู้ใช้',
    title: 'การจัดการผู้ใช้',
    subtitle: 'จัดการข้อมูลประจำตัวของผู้ใช้ รวมถึงการสร้างผู้ใช้ แก้ไขข้อมูลผู้ใช้ ดูบันทึกล็อกอินของผู้ใช้ รีเซ็ตรหัสผ่าน และลบผู้ใช้',
    create: 'เพิ่มผู้ใช้',
    create_subtitle: 'โปรดกรอกอย่างน้อยหนึ่งช่องจากด้านล่างเพื่อดำเนินการต่อ',
    error_missing_identifier: 'คุณต้องกรอกข้อมูลระบุตัวตนอย่างน้อยหนึ่งช่องเพื่อสร้างผู้ใช้',
    user_name: 'ผู้ใช้',
    application_name: 'จากแอปพลิเคชัน',
    latest_sign_in: 'เข้าสู่ระบบล่าสุด',
    create_form_username: 'ชื่อผู้ใช้',
    create_form_password: 'รหัสผ่าน',
    create_form_name: 'ชื่อ-นามสกุล',
    placeholder_name: 'John/Jane Doe',
    placeholder_email: 'jdoe@example.com',
    placeholder_username: 'user123',
    placeholder_phone: '+1 (555) 555-5555',
    unnamed: 'ไม่มีชื่อ',
    search: 'ค้นหาด้วยชื่อ อีเมล เบอร์โทรศัพท์ หรือชื่อผู้ใช้',
    check_user_detail: 'ตรวจสอบรายละเอียดผู้ใช้',
    placeholder_title: 'การจัดการผู้ใช้',
    placeholder_description: 'ผู้ใช้แต่ละคนจะมีโปรไฟล์ที่รวบรวมข้อมูลทั้งหมดของผู้ใช้ ประกอบด้วยข้อมูลพื้นฐาน ตัวตนโซเชียล และข้อมูลแบบกำหนดเอง',
};
export default Object.freeze(users);
